/* Smooth scroll, the way the reference does it.
 *
 * The reference runs Lenis - its <html> carries the `lenis` class - so this
 * runs the same library rather than an approximation. Lenis leaves the native
 * scrollbar and the real scroll position alone and only eases how the page
 * catches up, which is why it does not break anchor links, find-in-page, or a
 * screen reader's own scrolling the way a transform-based fake does.
 *
 * THREE THINGS IT MUST NOT DO, and each is guarded:
 *
 * 1. Run for anyone who asked for less motion. prefers-reduced-motion means
 *    the page scrolls natively, with no easing at all.
 * 2. Fight the theme editor. Shopify's editor scrolls the preview itself when
 *    a merchant selects a section, and a smooth-scroll layer makes that fight
 *    visible, so it stays off in Design mode.
 * 3. Hold on when the tab is hidden. The rAF loop is stopped on
 *    visibilitychange, because a loop running against a hidden tab is a
 *    battery cost with nothing on the other side of it.
 */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduce.matches) return;
  if (window.Shopify && window.Shopify.designMode) return;
  if (typeof Lenis !== 'function') return;

  /* READ OFF THE REFERENCE'S LIVE INSTANCE, not guessed.
   *
   * The first version of this used `duration: 1.1`, and that is why it felt
   * different. Lenis takes EITHER a lerp OR a duration and they are not the
   * same easing at all: a duration animates over a fixed time regardless of
   * how far the page has to go, while a lerp closes a fixed FRACTION of the
   * remaining distance every frame. The lerp is what gives that long,
   * decelerating tail on a big flick and an almost immediate response on a
   * small one - which is the thing that reads as "smoother".
   *
   * Their exact options: lerp 0.1, no duration, smoothWheel, syncTouch off,
   * both multipliers 1, vertical, autoResize. The easing function below is
   * theirs character for character.
   */
  var lenis = new Lenis({
    lerp: 0.1,
    easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
    smoothWheel: true,
    syncTouch: false,
    wheelMultiplier: 1,
    touchMultiplier: 1,
    orientation: 'vertical',
    gestureOrientation: 'vertical',
    infinite: false,
    autoResize: true
  });

  var frame = null;
  function raf(time) {
    lenis.raf(time);
    frame = requestAnimationFrame(raf);
  }
  function start() { if (frame === null) frame = requestAnimationFrame(raf); }
  function stop() { if (frame !== null) { cancelAnimationFrame(frame); frame = null; } }

  start();

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { stop(); } else { start(); }
  });

  reduce.addEventListener('change', function (e) {
    if (e.matches) { stop(); lenis.destroy(); } else { start(); }
  });

  /* NESTED HORIZONTAL SCROLLERS HAVE TO OPT OUT, OR THEY FIGHT THIS.
   *
   * Lenis listens for wheel on the window and eases the PAGE. A trackpad
   * sends deltaX and deltaY together, so a sideways swipe over one of the
   * house's rails arrives as a wheel event Lenis also wants to act on: the
   * rail moves natively, the page eases at the same time, and the gesture
   * reads as sticking and jumping. That is the bug, and it is not the rail's
   * own CSS - snap is `proximity` everywhere and was never the cause.
   *
   * Lenis's own escape hatch is a `data-lenis-prevent` attribute, which it
   * checks by walking up from the event target. Rather than hand-tag a dozen
   * elements across as many section files and miss the next one somebody
   * adds, every element that actually scrolls sideways is tagged here, at
   * runtime, from what the layout really computes.
   *
   * Re-run on resize because a rail that fits at 1600 overflows at 1200, and
   * on load because images decide the final widths.
   */
  function tagNestedScrollers() {
    var nodes = document.querySelectorAll('*');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.scrollWidth <= el.clientWidth + 4) continue;
      var ox = getComputedStyle(el).overflowX;
      if (ox !== 'auto' && ox !== 'scroll') continue;
      el.setAttribute('data-lenis-prevent', '');
    }
  }

  tagNestedScrollers();
  window.addEventListener('load', tagNestedScrollers);

  var resizeTimer = null;
  window.addEventListener('resize', function () {
    if (resizeTimer !== null) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(tagNestedScrollers, 200);
  });

  window.hbLenis = lenis;
})();
